// extracted by mini-css-extract-plugin
module.exports = {"icon":"RadioForm_icon__1C8w9","input":"RadioForm_input__zIdxM","label":"RadioForm_label__QZeYF"};